import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, CreditCard, Percent } from 'lucide-react';

export default function Sidebar() {
  const { pathname } = useLocation();

  const menu = [
    { title: 'داشبورد', path: '/', icon: <LayoutDashboard size={18} /> },
    { title: 'کاربران', path: '/users', icon: <Users size={18} /> },
    { title: 'پرداخت‌ها', path: '/payments', icon: <CreditCard size={18} /> },
    { title: 'تخفیف‌ها', path: '/discounts', icon: <Percent size={18} /> },
  ];

  return (
    <aside className="w-64 bg-white border-l shadow-sm hidden md:block">
      <div className="p-5 font-bold text-xl border-b text-gray-700">
        پنل مدیریت دوره{' '}
      </div>

      <nav className="p-4">
        {menu.map((item) => {
          const active = pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`
                flex items-center gap-3 px-3 py-2 rounded-md mb-1
                transition-all
                ${
                  active
                    ? 'bg-blue-100 text-blue-700 font-semibold'
                    : 'text-gray-700 hover:bg-gray-100'
                }
              `}>
              <span>{item.icon}</span>
              <span>{item.title}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
